module.exports = __webpack_public_path__ + "static/philosophy-439307bdf7af5eb4ac6b2bf40d2d09fd.svg";